import { ReactionTypeId } from 'src/constants/reaction';
import { TopicReaction } from 'src/types/helpdesk/reaction.type';
import {
  FilePathResponse,
  IFilePath,
  ITopic,
  ITopicDetail,
  ITopicMember,
  ITopicsParams,
  TopicMemberAdd
} from 'src/types/helpdesk/topic.type';
import { PagedList } from 'src/types/pagedList.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'helpdesk/topics';

export const getTopics = async (params: ITopicsParams) =>
  await http.get<PagedList<ITopic>>(controller, {
    params: params
  });

export const getTopicDetails = async (id: string, isEvent: boolean | undefined, fromDate: Date | undefined) =>
  await http.get<ITopicDetail[]>(`${controller}/get-topic-details-by-topic-id/${id}`, {
    params: { isEvent, fromDate }
  });

export const getTopic = async (id: string) => await http.get<ITopic>(`${controller}/${id}`);

export const getPinTopicDetails = async (id: string) =>
  await http.get<ITopicDetail[]>(`${controller}/get-topic-details-pinned/${id}`);

export const getContentBySearchCondition = async (topicId: string, searchCondition: string) =>
  await http.get<ITopicDetail[]>(
    `${controller}/get-contents-by-condition?searchCondition=${searchCondition}&topicId=${topicId}`
  );

export const getTopicBySearchCondition = async (searchCondition: string) =>
  await http.get<ITopic[]>(`${controller}/get-topics-by-code=${searchCondition}`);

export const pinTopicDetail = async (topicId: string, topicDetailId: string, isUnPin: boolean) =>
  await http.put(`${controller}/update-pin?topicId=${topicId}&id=${topicDetailId}&isUnPin=${isUnPin}`);

export const addTopicMember = async (id: string, data: TopicMemberAdd[]) =>
  await http.put<TopicMemberAdd[]>(`${controller}/add-topic-members/${id}`, data);

export const updateTopicMember = async (data: TopicMemberAdd) =>
  await http.put<TopicMemberAdd>(`${controller}/edit-topic-member`, data);

export const renameTopic = async (id: string, newName: string) =>
  await http.put(`${controller}/rename/${id}`, { name: newName });

export const deleteTopicMember = async (id: string) => await http.put(`${controller}/delete-topic-member?id=${id}`);

export const getTopicMembers = async (id: string) =>
  await http.get<ITopicMember[]>(`${controller}/get-topic-members-by-topic-id/${id}`);

export const getTopicAttachments = async (id: string) =>
  await http.get<IFilePath[]>(`${controller}/get-attachments-by-topic-id/${id}`);

export const addTopicDetail = async (topicId: string, body: ITopicDetail) =>
  await http.put(`${controller}/add-topic-detail/${topicId}`, body);

export const deleteTopicDetail = async (topicDetailId: string) =>
  await http.put(`${controller}/delete-topic-detail/${topicDetailId}`);

export const uploadTopicFile = async (formData: FormData) => {
  return await http.post<FilePathResponse[]>(`${controller}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getTopicFile = async (fileUrl: string, fileName: string) => {
  return await http.get<Blob>(`${controller}/get-file`, {
    params: {
      fileUrl: fileUrl,
      fileName: fileName
    },
    responseType: 'blob',
    timeout: 5000
  });
};

// reaction

export const addTopicReaction = async (topicDetailId: string, eEmojiType: ReactionTypeId) =>
  await http.put<TopicReaction>(`${controller}/add-topic-reaction/${topicDetailId}`, eEmojiType);

export const updateTopicReaction = async (topicDetailId: string, eEmojiType?: ReactionTypeId) =>
  await http.put<ITopicMember[]>(`${controller}/edit-topic-reaction/${topicDetailId}`, eEmojiType);

export const deleteTopicReaction = async (topicDetailId: string) =>
  await http.delete<ITopicMember[]>(`${controller}/delete-topic-reaction/${topicDetailId}`);

export const updateLastActivity = async (topicId: string, lastActivity: string) =>
  await http.put(`${controller}/read-all-messages`, null, { params: { topicId: topicId, lastActivity: lastActivity } });
